<div class="layoutColumn">

    <div style="padding: 20px;">
        <button mat-button (click)="saveImage()">Finish</button>
    </div>

    <img #image [src]="imageSource" alt="uploaded Photo" crossorigin style="max-height: 80vh; max-width: 100%;">
</div>